import { type ReactNode } from 'react';
import { useStyle } from 'react-native-style-utilities';
import { LabelText, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const ExpoRouterDemoTitle = (params: Props) => {
  const { children, color = theme.colors.KALE } = params;

  const textDynamicStyles = useStyle(() => ({ color }), [color]);

  return (
    <LabelText bold style={textDynamicStyles}>
      {children}
    </LabelText>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  children: ReactNode;
  color?: string;
};
